module.exports = __webpack_public_path__ + "img/comment-index.a819addd.png";